import { websocketclientApi, o2oApi} from 'yxt-biz-pc/packages/api';

export const askQuestion = (data, config) => websocketclientApi.post('createSse', data, config);
export const stopQuestion = (id) => websocketclientApi.get('openai/stop?messageId=' + id);
// 已引导
export const addGuide = data => o2oApi.post('/guide/addGuide', data);

// 校验是否已引导
export const checkGuide = params => o2oApi.get('guide/checkGuide', {params});
